import React from "react";
import ReactDOM from "react-dom/client";
import "./globals.css";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { Hub } from "aws-amplify/utils";
import { amplifyConfig } from "./config";

// Debug: Log the Amplify config
console.log("Amplify OAuth Config:", {
  domain: amplifyConfig.Auth?.Cognito?.loginWith?.oauth?.domain,
  redirectSignIn: amplifyConfig.Auth?.Cognito?.loginWith?.oauth?.redirectSignIn,
  redirectSignOut: amplifyConfig.Auth?.Cognito?.loginWith?.oauth?.redirectSignOut,
  region: amplifyConfig.Auth?.Cognito?.region,
  userPoolId: amplifyConfig.Auth?.Cognito?.userPoolId,
  userPoolClientId: amplifyConfig.Auth?.Cognito?.userPoolClientId,
});

// Configure Amplify with ssr: false to enable client-side OAuth handling
Amplify.configure(amplifyConfig, { ssr: false });

// Set up Hub listener BEFORE rendering to catch OAuth callbacks
// This ensures we don't miss the signInWithRedirect event
Hub.listen("auth", ({ payload }) => {
  console.log("[Bootstrap] Auth Hub event:", payload.event);
});

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

